import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	lists: [],
	isLoading: false
}

const listsSlice = createSlice({
	name: "lists",
	initialState,
	reducers: {
		addTaskInList(state, action) {
			const { index, task } = action.payload;
			state.lists[index]?.tasks?.unshift(task)
		},
		updateTaskInList(state, action) {
			const { index, taskIndex, task } = action.payload;
			state.lists[index]?.tasks?.splice(taskIndex, 1, task);
		},
		moveTaskInList(state, action) {
			const { task, fromIndex, toIndex } = action.payload;
			state.lists[toIndex]?.tasks?.push(task);
			state.lists[fromIndex].tasks = state.lists[fromIndex]?.tasks?.filter(
				(t) => t?._id !== task?._id
			);
		},
		deleteTaskInList(state, action) {
			const { index, task } = action.payload;
			state.lists[index].tasks = state.lists[index]?.tasks?.filter(
				(t) => t?._id !== task?._id
			);
		},
		setLists(state, action) {
			state.lists = action.payload;
			state.isLoading = false;
		},
		setListIsLoading(state, action) {
			state.isLoading = true;
		}
	}
});

export const { addTaskInList, updateTaskInList, moveTaskInList, deleteTaskInList, setLists, setListIsLoading } = listsSlice.actions
export default listsSlice.reducer;
